import React from 'react';
import { Dialog, IconButton, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { Button, Typography } from 'components/index';
import ProjectsList from 'pages/ProjectsList';
import CloseIcon from '@mui/icons-material/Close';
import { GridRowId } from '@mui/x-data-grid';

interface ProjectCompsDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect?: (selectedProjects: readonly GridRowId[], filterString?: string) => void;
  isFromReport?: boolean;
  disabledCompsIds?: string[];
  isAdding?: boolean;
  defaultOnDisplayFilters?: string[];
  prevAppliedFilters?: string;
  projectSearchQuery?: string;
  disableChecboxSelectionOnMaps?: boolean;
}

const ProjectCompsDialog: React.FC<ProjectCompsDialogProps> = ({
  open,
  onClose,
  onSelect,
  isFromReport,
  disabledCompsIds,
  isAdding,
  defaultOnDisplayFilters,
  prevAppliedFilters,
  projectSearchQuery,
  disableChecboxSelectionOnMaps,
}) => {
  const [selectedProjects, setSelectedProjects] = React.useState<readonly GridRowId[]>([]);
  const [addCompFilterString, setAddCompFilterString] = React.useState('');

  React.useEffect(() => {
    if (open) {
      setSelectedProjects([]);
      setAddCompFilterString('');
    }
  }, [open]);

  const handleSelect = () => {
    if (onSelect) {
      onSelect(selectedProjects, addCompFilterString);
    }
    onClose();
    setSelectedProjects([]);
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '1500px',
          height: '900px',
        },
      }}
      fullWidth
      maxWidth='xl'
    >
      <DialogTitle sx={{ paddingBottom: 0, display: 'flex', alignItems: 'baseline', gap: 1 }}>
        {projectSearchQuery ? 'Projects' : 'Select Comparables'}
        {!projectSearchQuery && selectedProjects.length > 0 && (
          <Typography variant='subtitle2' color='text.secondary'>
            ({selectedProjects.length} selected)
          </Typography>
        )}
      </DialogTitle>
      <IconButton onClick={onClose} style={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ paddingTop: 0 }}>
        <ProjectsList
          onProjectsSelect={(selected: readonly GridRowId[], filterString?: string) => {
            setSelectedProjects(selected);
            if (!filterString) {
              setAddCompFilterString(JSON.stringify(''));
            } else {
              setAddCompFilterString(filterString);
            }
          }}
          isFromReport={isFromReport}
          disabledProjectsIds={disabledCompsIds}
          defaultOnDisplayFilters={defaultOnDisplayFilters}
          prevAppliedFilters={prevAppliedFilters}
          shouldRenderMinimalActions={true}
          projectSearchQuery={projectSearchQuery}
          disableChecboxSelectionOnMaps={disableChecboxSelectionOnMaps}
        />
      </DialogContent>

      <DialogActions>
        {!projectSearchQuery && (
          <Button variant='contained' onClick={handleSelect} color='primary' loading={isAdding}>
            {selectedProjects.length > 0 ? `Add ${selectedProjects.length} selected` : 'Add'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(ProjectCompsDialog);
